import axios from 'axios';
import { useQuery } from 'react-query';
import { SortValue, Tournaments } from '../api/responses';

export const useGetTournaments = (
    page: number,
    isEnable: boolean,
    sortValue: SortValue
) => {
    const getTournaments = async (): Promise<Tournaments> => {
        const params: any = {
            page: page,
            page_size: 10,
            sort: sortValue,
        };

        const tours = await axios
            .get(`${process.env.REACT_APP_API_URL}/competitions/`, {
                params,
            })
            .then((res) => res.data);
        return tours;
    };

    const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
        queryKey: ['get-tours', { page, sortValue }],
        queryFn: getTournaments,
        enabled: isEnable,
        retry: 3,
    });

    return { data, isError, isLoading, error, isFetching, refetch };
};
